export default function($) {
  const cartToggle = $('.js-cart-toggle');
  const miniCart = $('#mini-cart-panel');
  const overlay = $('.mini-cart-overlay');
  const closeBtn = $('#mini-cart-close');

  const openCart = () => {
    miniCart.removeClass('translate-x-full invisible').addClass('visible');
    overlay.removeClass('opacity-0 pointer-events-none').addClass('opacity-25');
    miniCart.attr('tabindex', '-1');
    setTimeout(() => miniCart.trigger('focus'), 300);
  }
  const closeCart = () => {
    miniCart.addClass('translate-x-full invisible').removeClass('visible');
    overlay.removeClass('opacity-25').addClass('opacity-0 pointer-events-none');
  }

  cartToggle.on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    miniCart.hasClass('translate-x-full') ? openCart() : closeCart();
    cartToggle.first().trigger('focus');
  });

  closeBtn.on('click', function(e) {
    e.stopPropagation();
    closeCart();
    cartToggle.first().trigger('focus');
  });

  overlay.on('click', closeCart);

  $(document).on('click', function(e) {
    if (!$(e.target).closest('#mini-cart-panel, .js-cart-toggle').length) {
      closeCart();
    }
  });

  // AJAX quantity update
  let updateTimer = null;

  $(document).on('change', '#mini-cart-panel input.qty', function() {
    if (typeof gt_configuration === 'undefined') return;

    clearTimeout(updateTimer);

    const $input = $(this);
    const match = $input.attr('name').match(/cart\[([^\]]+)\]\[qty\]/);
    if (!match) return;

    const cartItemKey = match[1];
    const quantity = parseInt($input.val(), 10) || 0;

    $('#mini-cart-panel .cart-items-wrapper').css('opacity', '0.5');

    updateTimer = setTimeout(function() {
      $.post(
        gt_configuration.ajax_url,
        {
          action: 'gt_update_mini_cart_qty',
          nonce: gt_configuration.miniCart.updateNonce,
          cart_item_key: cartItemKey,
          quantity: quantity,
        },
        function(response) {
          if (response && response.success && response.data.fragments) {
            $.each(response.data.fragments, function(key, value) {
              $(key).replaceWith(value);
            });
            $(document.body).trigger('wc_fragments_refreshed');
          } else {
            $('#mini-cart-panel .cart-items-wrapper').css('opacity', '1');
          }
        }
      );
    }, 500);
  });
}
